var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneStage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.6314 12.4399L4.69391 24.6249C4.55284 24.8174 4.48526 25.054 4.50337 25.292C4.52148 25.5299 4.62409 25.7535 4.79266 25.9224L6.58016 27.7099C6.74907 27.8785 6.9727 27.9811 7.21065 27.9992C7.4486 28.0173 7.68518 27.9498 7.87766 27.8087L20.0627 18.8749C18.4639 18.5826 16.9921 17.8102 15.8432 16.6606C14.6943 15.5111 13.9228 14.0389 13.6314 12.4399Z",
    fill: "#B8772A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 19C25.9183 19 29.5 15.4183 29.5 11C29.5 6.58172 25.9183 3 21.5 3C17.0817 3 13.5 6.58172 13.5 11C13.5 15.4183 17.0817 19 21.5 19Z",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1562 16.6562L15.8438 5.34375",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20L13.5 19",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6252 12.4375L4.69391 24.625C4.55284 24.8175 4.48526 25.0541 4.50337 25.292C4.52148 25.53 4.62409 25.7536 4.79266 25.9225L6.58016 27.71C6.74907 27.8786 6.9727 27.9812 7.21065 27.9993C7.4486 28.0174 7.68518 27.9498 7.87766 27.8088L20.0627 18.875",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneStage);
export default __webpack_public_path__ + "static/media/MicrophoneStage.7d6d7117b6c133a67a8a43aa5e8dffab.svg";
export { ForwardRef as ReactComponent };